export default __webpack_public_path__ + "static/media/31_Dear.ffd744b3.JPG";